import type { Stage } from '../../types';

export const postpartumEarly: Stage = {
  id: 'postpartum-early',
  key: '5',
  title: '産後0–3ヶ月',
  subtitle: '新しい命を迎える日々',
  weeks: '産後0–3ヶ月',
  description: '授乳や睡眠のリズムが定まらない日々です。無理をせず、ママ自身の回復も大切にしましょう。',
  mindCards: [
    { id: 'm1', title: '完璧を求めない', body: '小さな命を迎えて、正解は1つではありません。', type: 'mind' },
    { id: 'm2', title: '1つずつ慣れる', body: '骨盤底筋や無理のない運動を、産院の指導に従って始めましょう。', type: 'body' },
    { id: 'm3', title: '外出は短時間から', body: '自分のテンポを大切に、無理のない範囲で出かけましょう。', type: 'life' },
    { id: 'm4', title: '夜間を支え合う', body: '夜間の授乳をサポートし、ママを休ませる工夫をしましょう。', type: 'mind' },
    { id: 'm5', title: '相談は強み', body: '育児の悩みは一人で抱えず、専門家や自治体に相談できます。', type: 'mind' },
    { id: 'm6', title: '夫婦の時間を大切に', body: '短くても話す時間を作り、二人の調整を続けましょう。', type: 'partner' },
    { id: 'm7', title: '授乳はママのペースで', body: '母乳が足りないと感じたらミルクを併用。ママの心身を守ることが最優先です。', type: 'body' },
  ],
  checklist: [
    { id: 'c1', text: '自宅での出生届を提出する', category: 'admin', note: '出産後14日以内' },
    { id: 'c2', text: '児童手当・特例給付の申請を確認する', category: 'admin', note: '自治体からの案内を確認' },
    { id: 'c3', text: '1ヶ月健診・予防接種スケジュールを確認する', category: 'hospital', note: '母子手帳に記録' },
    { id: 'c4', text: '授乳や睡眠の記録を始める', category: 'life', note: 'アプリや手帳でOK' },
    { id: 'c5', text: '骨盤底筋体操を始める（指導に従う）', category: 'body', note: '無理のない範囲で' },
    { id: 'c6', text: '産後の健康診査（6週）を予約する', category: 'hospital', note: '産院または自治体' },
    { id: 'c7', text: '産後の相談窓口（自治体・保健所）を確認する', category: 'mind', note: '夜間電話相談もある' },
    { id: 'c8', text: '家事のテンポを下げる', category: 'life', note: '掃除は最低限に' },
    { id: 'c9', text: 'パートナーとの夜間・休日交代を決める', category: 'partner', note: '休息を均等に' },
    { id: 'c10', text: '短時間の外出を計画する', category: 'life', note: '1〜2時間程度から' },
    { id: 'c11', text: '育児の不安を相談できる人を決める', category: 'mind', note: '助産師・保健師・先輩ママ' },
    { id: 'c12', text: 'ベビー用の身の回り品を整理する', category: 'life', note: 'おむつ・着替えの動線' },
    { id: 'c13', text: '授乳の姿勢や乳首のケアを確認する', category: 'body', note: '痛みが続く場合は相談' },
    { id: 'c14', text: 'お宮参りの準備をする', category: 'life', note: '服装・日程・お守りなど' },
    { id: 'c15', text: '予防接種の予約を入れる', category: 'hospital', note: 'BCG・ロタ・Hibなど' },
    { id: 'c16', text: 'ママの食事と睡眠を優先する', category: 'mind', note: '赤ちゃんと同じリズムで休む' },
    { id: 'c17', text: 'パートナーへの感謝を口にする', category: 'partner', note: '小さなことでも伝える' },
    { id: 'c18', text: '育児グッズの買い足しを計画する', category: 'shopping', note: 'おむつ・おしり拭きなど' },
    { id: 'c19', text: 'こども医療費助成の申請をする', category: 'admin', note: '自治体により対象年齢や助成内容が異なります。健康保険加入後に手続き。' },
    { id: 'c20', text: '児童手当の申請をする', category: 'admin', note: '0歳児は満3歳まで月額15,000円（所得制限あり）。出生した月の月末までに。' },
    { id: 'c21', text: '新潟県こむすび定期の申請を確認する', category: 'admin', note: '新潟県内で生まれた1歳未満の子どもが対象。1歳の誕生日前日までに申請。' },
    { id: 'c22', text: '新生児訪問（こんにちは赤ちゃん）の予約を受ける', category: 'hospital', note: '自治体からの案内。育児や健康の相談に活用。' },
    { id: 'c23', text: '産後の健康診査（6〜8週）を予約する', category: 'hospital', note: '子宮の回復・貧血・血圧・乳・骨盤底筋などを確認' },
    { id: 'c24', text: 'ママの口腔ケアと産後の栄養を整える', category: 'body', note: '授乳期も鉄分・カルシウムを意識。授乳期は+450kcal目安（一般論）' },
    { id: 'c25', text: '育児の不安を相談できる窓口を確認する', category: 'mind', note: '新潟市助産師会「ハロー！ミッドワイフ」や各区のこども家庭センターなど' },
    { id: 'c26', text: '母乳・ミルクの併用を焦らない', category: 'body', note: '母乳が十分でない場合はミルクを併用。産婦人科や助産師に相談。' },
    { id: 'c27', text: '自宅の受動喫煙防止を徹底する', category: 'life', note: '妊婦・乳幼児のそばでは絶対に禁煙' },
    { id: 'c28', text: 'ママの食事は+450kcal目安でバランスを整える', category: 'body', note: '一汁三菜を基本に、鉄分・カルシウムを意識' },
  ],
  shopping: [
    { id: 's1', name: '抱っこ紐（新生児対応）', priority: 'should', timing: '産後0〜3ヶ月', priceYenMin: 3000, priceYenMax: 15000, note: '首すわり前対応を確認' },
    { id: 's2', name: '授乳ブラ（産後サイズ）', priority: 'must', timing: '産後0〜3ヶ月', priceYenMin: 2000, priceYenMax: 6000, note: '楽な着け心地を優先' },
    { id: 's3', name: 'おしり拭き（大量）', priority: 'must', timing: '産後0〜3ヶ月', priceYenMin: 2000, priceYenMax: 6000, note: '新生児用の低刺激タイプ' },
    { id: 's4', name: 'ベビー沐浴タオル', priority: 'should', timing: '産後0〜3ヶ月', priceYenMin: 1000, priceYenMax: 3000, note: 'ガーゼ素材が人気' },
    { id: 's5', name: 'ベビーモニター', priority: 'nice', timing: '産後0〜3ヶ月', priceYenMin: 5000, priceYenMax: 20000, note: 'カメラ付きなどタイプ多数' },
    { id: 's6', name: '授乳ケープ', priority: 'should', timing: '産後0〜3ヶ月', priceYenMin: 2000, priceYenMax: 5000, note: '外出時に便利' },
    { id: 's7', name: '産後ショーツ・骨盤ベルト', priority: 'should', timing: '産後0〜3ヶ月', priceYenMin: 2000, priceYenMax: 6000, note: '医師や助産師の指導に従う' },
    { id: 's8', name: '搾乳機（電動または手動）', priority: 'nice', timing: '産後0〜3ヶ月', priceYenMin: 3000, priceYenMax: 20000, note: '母乳の量や生活に合わせて' },
    { id: 's9', name: 'ベビー用爪切り', priority: 'should', timing: '産後0〜3ヶ月', priceYenMin: 500, priceYenMax: 2000, note: '新生児用の安全設計' },
    { id: 's10', name: 'ママ用リラックスグッズ', priority: 'nice', timing: '産後0〜3ヶ月', priceYenMin: 1000, priceYenMax: 5000, note: '入浴剤・アイマスクなど' },
    { id: 's11', name: 'おむつ用ゴミ箱', priority: 'nice', timing: '産後0〜3ヶ月', priceYenMin: 2000, priceYenMax: 6000, note: '臭い対策に' },
    { id: 's12', name: '哺乳瓶消毒器', priority: 'nice', timing: '産後0〜3ヶ月', priceYenMin: 2000, priceYenMax: 8000, note: '電子レンジ・薬液・煮沸などタイプを選ぶ' },
  ],
  warnings: [
    { id: 'w1', label: '大量の悪露', level: 'urgent' },
    { id: 'w2', label: '39℃以上の高熱', level: 'urgent' },
    { id: 'w3', label: '胸痛', level: 'urgent' },
    { id: 'w4', label: '意識がもうろうとする', level: 'urgent' },
    { id: 'w5', label: '赤ちゃんの呼吸困難', level: 'urgent' },
    { id: 'w6', label: '悪露の臭い・量の増加', level: 'watch' },
    { id: 'w7', label: '傷の痛み', level: 'watch' },
    { id: 'w8', label: '授乳痛', level: 'watch' },
    { id: 'w9', label: '気分の落ち込み', level: 'watch' },
    { id: 'w10', label: '赤ちゃんの食欲低下', level: 'watch' },
    { id: 'w11', label: 'おへその出血・化膿', level: 'watch' },
    { id: 'w12', label: '黄疸が強い・長引く', level: 'watch' },
  ],
  partner: [
    { id: 'p1', text: '夜間の授乳をサポートする' , detail: '夜間授乳のサポート（抱っこ、寝かしつけ、哺乳瓶時の調乳）を交代で。'},
    { id: 'p2', text: '家事を主導してママを休ませる' , detail: '家事の主導権をパパ側に。ママは回復が最優先と明言する。'},
    { id: 'p3', text: 'ママの様子を観察し、相談を促す' , detail: '食欲・睡眠・涙もろさなど様子を見守り、必要なら一緒に相談窓口へ。'},
    { id: 'p4', text: 'おむつ替え・沐浴を一緒に覚える' , detail: 'おむつ替え・沐浴を一緒に練習し、手順を写真やメモで残す。'},
    { id: 'p5', text: '週末はママの睡眠時間を作る' , detail: '週末はママが連続して眠れる時間を確保（外出・来客を調整）。'},
    { id: 'p6', text: '育児の悩みを一緒に相談する' , detail: '育児の悩みは二人で整理し、保健師や産院に相談する選択肢を持つ。'},
    { id: 'p7', text: '予防接種や健診に同行する' , detail: '予防接種・健診の予定を共有カレンダーへ。同行できる日を先に入れる。'},
    { id: 'p8', text: '二人の時間を意識して作る' , detail: '短時間でも二人で話す・休む時間を週に一度つくる。'},
    { id: 'p9', text: '産後パパ育休を取得する' , detail: '産後パパ育休を実際に取得し、夜間・日中の主担当を明確にする。'},
  ],
  tips: [
    {
      id: 't1',
      title: '睡眠は「赤ちゃんと一緒に寝る」',
      body: '夜間の授乳で睡眠が削られがち。昼間も赤ちゃんが寝たら一緒に横になると、回復が違います。',
    },
    {
      id: 't2',
      title: '授乳の悩みは早めに相談',
      body: '乳首の痛みや乳腺炎の兆候は、母乳外来や助産師に相談。一人で我慢しなくて大丈夫。',
    },
    {
      id: 't3',
      title: '家事は「minimum（最低限）」で',
      body: '掃除や洗濯は必要最小限に。惣菜や宅配を活用。産後のママはまだ回復途中です。',
    },
    {
      id: 't4',
      title: '外出はテンポを大切に',
      body: '初めての外出は1〜2時間程度。授乳スペースのある施設を選び、無理なく慣らしていきましょう。',
    },
    {
      id: 't5',
      title: '産後うつは早期相談を',
      body: '気分が落ち込みやすい時期。自分を責めず、産婦人科・精神科・自治体相談窓口を活用しましょう。',
    },
    {
      id: 't6',
      title: '育児の不安は相談が強み',
      body: '新潟市助産師会「ハロー！ミッドワイフ」や各区のこども家庭センター（ほっとステーション）、LINE相談など活用できます。',
    },
    {
      id: 't7',
      title: '母乳・ミルクは併用OK',
      body: '母乳にこだわりすぎないで。ママのストレスが少ない方法を選び、助産師や産婦人科に相談しましょう。',
    },
    {
      id: 't8',
      title: '食事は授乳期も+450kcal目安',
      body: '一汁三菜を基本に、鉄分・カルシウムを意識。授乳期は水分もしっかり取りましょう。',
    },
    {
      id: 't9',
      title: '受動喫煙を防ぐ',
      body: '乳幼児のそばではたばこを吸わないルールを徹底。加熱式たばこも含め、副流煙は防げません。',
    },
    {
      id: 't10',
      title: '急な病気は#8000',
      body: '新潟市などの「こども医療電話相談#8000」で、休日・夜間の受診の目安を看護師等に相談できます。',
    },
  ],
  adminGuide: [
    { id: 'a1', title: '出生届の提出期限', body: '出産後14日以内に市区町村へ。夫婦のどちらかが提出。母子手帳や健診券の受け取りもセットで行われます。', when: '出産後14日以内' },
    { id: 'a2', title: '児童手当の申請', body: '0歳児は満3歳まで月額15,000円（所得制限あり）。自治体の児童課へ申請。所得制限により減額・不支給の場合もあります。', when: '出生後すぐ' },
    { id: 'a3', title: '乳児医療証の交付', body: '小児科受診時に提示すると医療費の助成を受けられます。自治体により対象年齢や助成内容が異なります。', when: '出生届提出後' },
    { id: 'a4', title: '予防接種の予診票', body: '母子手帳に記載されたスケジュールに沿って接種。ロタウイルス・Hib・肺炎球菌などの任意接種も検討。', when: '1〜2ヶ月頃から' },
    { id: 'a5', title: '産後の健康診査', body: '産後6〜8週間で受診。子宮の回復・貧血・血圧・乳・骨盤底筋などを確認。自治体の無料検診もあります。', when: '産後6〜8週間' },
    { id: 'a6', title: '育休からの復帰準備', body: '復帰3〜4ヶ月前には会社と調整を。保育園申込みや勤務形態の相談もこの時期に始めます。', when: '産後2〜3ヶ月頃' },
    { id: 'a7', title: 'こども医療費助成の申請', body: '子どもの医療費の自己負担額を助成。自治体により対象年齢や助成内容が異なります。健康保険加入後に手続きを。', when: '出生後速やかに' },
    { id: 'a8', title: '新潟県こむすび定期の申請', body: '新潟県内で生まれた1歳未満の子どもが対象。10万円の定期預金を支給。1歳の誕生日前日までに県の電子申請システムから申請。', when: '1歳の誕生日前日まで' },
    { id: 'a9', title: '産後ケア事業の利用', body: '新潟市では宿泊型・デイ型・訪問型の産後ケアがあります。申請済みなら利用を、未申請なら相談を。', when: '産後〜生後6か月' },
    { id: 'a10', title: '父親の出生時育児休業', body: '出産後8週間以内に4週間まで取得可能。雇用保険から給付金が支給されます。会社へ2週間前までに申し出を。', when: '出産後8週間以内' },
  ],
  careScenes: [
    {
      id: 'cs1',
      title: '夜の寝かしつけ',
      items: [
        '部屋を暗くし、静かな環境にする',
        'おむつ替え・授乳・げっぷの流れを作る',
        '白噪音や優しい声かけで落ち着かせる',
        '昼夜のリズムはまだ定まらないことを受け入れる',
        'ママも一緒に休む時間を作る',
      ],
    },
    {
      id: 'cs2',
      title: '授乳・ミルク',
      items: [
        '母乳は需求で、ママの体調も大切',
        'ミルクは规定の量・温度・濃さで',
        '授乳後はげっぷを出す',
        '乳首の痛みが続いたら相談',
        '水分補給を忘れずに',
      ],
    },
    {
      id: 'cs3',
      title: 'おむつ替え',
      items: [
        '毎回おしりをやさしく拭く',
        'おむつかぶれ予防に保湿剤を薄く',
        '男の子も女の子も前から後ろへのふき方を',
        'おむつ替え台から目を離さない',
        'すぐに手を洗う',
      ],
    },
    {
      id: 'cs4',
      title: 'お出かけ',
      items: [
        'チャイルドシートの取り付けを確認',
        'おむつ・おしり拭き・着替えを多めに',
        '授乳スペースのある施設を選ぶ',
        '外出時間は短めに',
        'ママも水分と休息を確保',
      ],
    },
  ],
  exercises: [
    {
      id: 'ex1',
      title: '産後の呼吸とやさしいストレッチ（10分）',
      durationMin: 10,
      url: 'https://www.youtube.com/watch?v=2_uOYGstJj4',
      channel: '妊娠・産後エクササイズチャンネル',
      note: '産後は医師の許可を得てから。悪露や傷口に注意し、痛みがある場合は中止してください。まずは呼吸と軽いストレッチから。',
      level: 'gentle',
    },
  ],
};
